export const teamSettingsApiSelector = state => {
  return state.api.teamSettings;
};
